const breadcrumb = {
    Breadcrumb: {
        baseStyle: {
            container: {
                display: {base: 'none', md: 'flex'},
                py: 'spacing.6',
            },
            link: {
                color: 'color.text.breadcrumb.inactive',
                textDecoration: 'underline',
                fontWeight: '500',
                textStyle: 'paragraphSm',
                letterSpacing: '1px',
                _hover: {
                    textDecoration: 'underline',
                },
                // Chakra ui adds aria-current to the active breadcrumb item, so we apply styles on it
                '&[aria-current]': {
                    color: 'color.text.breadcrumb.active',
                    textDecoration: 'none',
                    _hover: {
                        textDecoration: 'none',
                    },
                },
            },
            item: {},
            separator: {
                color: 'color.text.breadcrumb.inactive',
                mx: 'spacing.2',
            },
        },
    },
}

export default breadcrumb
